<ng-container>
    <ng-template #default let-item>
        <span>{{ item.description }}</span>
    </ng-template>

    <ul [style]="{ padding: listPadding() }">
        <li
            *ngFor="let item of items()"
            (contextmenu)="onContextMenuItemClicked(item)"
            class="{{ item.itemClass || '' }}"
        >
            <ng-container
                *ngTemplateOutlet="
                    itemTemplate() ?? default;
                    context: { $implicit: item }
                "
            ></ng-container>

            <ng-container *ngIf="item.children && item.children.length > 0">
                <ng-container *ngFor="let subitem of item.children">
                    <ng-container
                        *ngTemplateOutlet="
                            itemTemplate() ?? default;
                            context: { $implicit: subitem }
                        "
                    ></ng-container>
                </ng-container>
            </ng-container>
        </li>
    </ul>
</ng-container>
